import React, { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import PageLoader from '../../component/Elements/pageLoader'

const CouponPage = React.memo(() => {
	return (
		<Suspense fallback={<PageLoader />}>
			<Outlet />
		</Suspense>
	)
})

CouponPage.displayName = 'CouponPage'
export default CouponPage
